import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.BUSCAR_HISTORICO_ALTERACAO_CLASSIFICACAO_FORNECEDORES](
		{ state },
		idAtaItem,
	) {
		const { data } = await api.alterarClassificacao.buscarHistoricoFornecedoresPorIdItemAtaPaginado(
			state.paginacao,
			idAtaItem,
		)

		return data
	},
}
